import type { ProgramUserRsvp } from 'models';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useEventRsvpLabels } from '../../../../hooks';

type EventInviteeStatusOption = {
  label: string;
  value: 'all' | ProgramUserRsvp;
};

const eventInviteesStatusValues: Array<'all' | ProgramUserRsvp> = ['all', 'going', 'pending', 'not_going'];

export const useEventInviteesStatusFilterOptions = () => {
  const { t } = useTranslation();
  const { getStatusListLabel } = useEventRsvpLabels();

  return useMemo(
    (): EventInviteeStatusOption[] =>
      eventInviteesStatusValues.map((value) => ({
        label: value === 'all' ? t('All') : getStatusListLabel({ rsvp: value }),
        value,
      })),
    [t, getStatusListLabel],
  );
};
